import { TestimonialVisibility } from "../enums/TestimonialVisibilityEnum";
import { TestimonialStatusEnum } from "../enums/TestimonialStatusEnum";
import dayjs from "dayjs";

export class BaseTestimonial {
    constructor(data) {
        this.id = data.id;
        this.title = data.title;
        this.type = data.type;
        this.visibility = data.visibility;
        this.createdAt = new Date(data.createdAt);
        this.status = data.status;

        this.author = data.author;
        this.video = data.video;
        this.products = data.products;
        this.industries = data.industries;
        this.language = data.language;

        this.share = data.share;
        this.formatter = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
        });
    }

    displayName() {
        const firstName = this.author?.firstName ?? "";
        const lastName = this.author?.lastName ?? "";

        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || "Unknown";
    }

    hasAuthor() {
        return !!this.author;
    }

    parseDate() {
        return this.createdAt.toLocaleString();
    }

    formattedDate() {
        return dayjs(this.createdAt).format("MMM DD YYYY");
    }

    isPrivate() {
        return this.visibility == TestimonialVisibility.private.value;
    }

    visibilityToolTip() {
        return this.isPrivate() == true
            ? "This testimonial is for internal use only."
            : "Anyone with the share link can watch this.";
    }

    getVideoThumbnail() {
        if (!this.video?.thumbnail) {
            return null;
        }

        const url = process.env.VUE_APP_API_URL;
        const imageUrl = `${url}/public/${this.id}/${this.video.thumbnail}`;
        return imageUrl;
    }

    getVideoDuration() {
        if (!this.video.duration) {
            return null;
        }

        const mins = Math.floor(this.video.duration / 60);
        const secs = Math.floor(this.video.duration % 60)
            .toString()
            .padStart(2, "0");

        return `${mins}:${secs}`;
    }

    canShare() {
        return this.isPrivate() == false && this.status == TestimonialStatusEnum.active && this.share.shareId;
    }

    generateShareLink() {
        return `${process.env.VUE_APP_BASE_URL}/share/${this.share.shareId}`;
    }
}
